module.exports = __webpack_public_path__ + "img/icon-assess.59722771.png";